import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="#DB0000"
      d="M5.174 8.413s-.632.925.196 2.12c0 0 .13-.609 1.437-.609h1.569c1.481 0 2.591-1.465 1.895-2.977 0 0 1.045.113 1.394-.564.349-.676-.022-.947-.544-.947H8.485c0 .485-.893.552-.893 0H6.111s-1.111 0-1.133.97c0 0 .251-.158.5-.18v.258s-.304.057-.446.136c-.141.079-.348.293-.152.846.196.552.273.744.273.744s.316-.283.828-.283h.6c1.066 0 .87 1.071-.197 1.071-1.068 0-1.209-.586-1.209-.586l-.001.001Z"
    />
    <path
      fill="#DB0000"
      d="M10.74 7.297s.359.023.62-.214c0 0 2.363 1.906-1.143 5.74-3.508 3.834-.796 6.316-.796 6.316S8.79 19.77 9.149 21c0 0-1.46-.853-2.575-2.301-1.612-2.093-2.598-5.295 1.83-7.85 0 0 2.923-1.522 2.335-3.552ZM7.127 5.075s.472-.872 1.568-.872c.864 0 1.06-.46 1.06-.46S10.134 3 12.036 3c1.744 0 2.92.602 3.87 1.406 0 0-2.563-1.647-5.09.67H7.127Z"
    />
    <path
      fill="#DB0000"
      d="M17.786 10.594c-.073-2.722-2.106-5.639-6.477-5.473 4.27-3.745 11.676 4.615 5.576 9.007 0 0 1.02-1.508.9-3.534Z"
    />
    <path
      fill="#DB0000"
      d="M11.963 5.421c5.33-.165 7.232 6.45 3.79 9.428l-3.456 1.73s-.45-1.504 1.22-3.264c1.671-1.758 3.282-5.051-1.335-7.217 0 0 .087-.45-.218-.676h-.001Z"
    />
    <path
      fill="#DB0000"
      d="M11.687 6.91s.261-.256.349-.466c3.964 1.713 3.34 4.616.972 7.052-1.452 1.548-1.002 3.218-1.002 3.218s-1.77 1.142-2.381 2.135c0 0-2.565-2.261.987-6.014 3.485-3.684 1.075-5.925 1.075-5.925Z"
    />
  </svg>
`;
